import { Pipe, PipeTransform } from '@angular/core';

/** Parsea YYYY-MM-DD como fecha local (evita desfase UTC). */
function parseNacimiento(nacimiento: string | Date): Date | null {
  if (nacimiento instanceof Date) {
    return Number.isNaN(nacimiento.getTime()) ? null : new Date(nacimiento.getTime());
  }

  const isoDay = /^(\d{4})-(\d{2})-(\d{2})/.exec(nacimiento.trim());
  if (isoDay) {
    return new Date(Number(isoDay[1]), Number(isoDay[2]) - 1, Number(isoDay[3]));
  }

  const parsed = new Date(nacimiento);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Calcula edad en anios a partir de una fecha de nacimiento (ISO o Date). */
export function calcEdadAnios(
  nacimiento: string | Date | null | undefined,
  hoy: Date = new Date(),
): number | null {
  if (nacimiento == null || nacimiento === '') {
    return null;
  }

  const birth = parseNacimiento(nacimiento);
  if (!birth) {
    return null;
  }

  let age = hoy.getFullYear() - birth.getFullYear();
  const monthDiff = hoy.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && hoy.getDate() < birth.getDate())) {
    age -= 1;
  }

  return age < 0 ? null : age;
}

@Pipe({
  name: 'edad',
  standalone: true,
  pure: true,
})
export class EdadPipe implements PipeTransform {
  transform(nacimiento: string | Date | null | undefined): string {
    const age = calcEdadAnios(nacimiento);
    if (age === null) {
      return '\u2014';
    }
    return `${age} a\u00f1os`;
  }
}
